var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-[#404040] h-[55px] md:h-[70px] flex items-center justify-center"},[_c('div',{staticClass:"md:text-[14px] text-[10px] text-center mx-2 md:mx-0"},[_vm._v(" "+_vm._s(_vm.$t("footer.premInternational"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }